import { defineStore } from "pinia";
import { ref } from "vue";
import { defaultCalcCostDetailData, } from "@erp/shared/components/ui/Document/CalcCost/const";
import { getObtainConfirmDetail, } from "@erp/shared/api/generated/wrappers/obtain";
export const useDocument = defineStore("obtain-useDocument", () => {
    const selectedData = ref(null);
    const basicInfo = ref(null);
    const laborList = ref([]);
    const writerInfo = ref({
        name: "",
        officePhoneNumber: "",
    });
    const calcData = ref(defaultCalcCostDetailData);
    const getDocumentData = async (id) => {
        const res = await getObtainConfirmDetail(id);
        selectedData.value = res;
        basicInfo.value = res.info;
        calcData.value = res.calc;
        writerInfo.value = {
            name: res.info.createrName ?? "",
            officePhoneNumber: res.info.createrPhoneNumber ?? "",
        };
        laborList.value = [...res.labor];
        return {
            selectedData: selectedData.value,
            basicInfo: basicInfo.value,
            calcData: calcData.value,
            writerInfo: writerInfo.value,
            laborList: laborList.value,
        };
    };
    return {
        selectedData,
        basicInfo,
        calcData,
        writerInfo,
        laborList,
        getDocumentData,
    };
});
